/**
 * Permission IDs used for menu visibility.
 * Source of truth: .amigrar/permisos/ — values must match the backend catalogue.
 * Only list-level ("LIS") permissions are used here; action-level permisos live in their feature modules.
 */
export const MenuPermissions = {
  // ── Inicio ─────────────────────────────────────────────────────────────────
  ARTICULOS: 1001,
  ATRIBUTOS: 1095,
  CTA_CTE: 1174,
  NOTAS_PEDIDO: 1166,

  // ── Autorización ───────────────────────────────────────────────────────────
  AUT_AUTORIZAR_COMPROBANTES: 1057,
  AUT_CONFIGURACION: 1051,
  AUT_RESPONSABLES: 1055,

  // ── Estadística ────────────────────────────────────────────────────────────
  EST_TABLEROS: 1151,
  EST_INDICADORES: 1158,

  // ── Producción ─────────────────────────────────────────────────────────────
  PRD_ARTICULOS: 1001,
  PRD_TERCERIZADOS: 1038,
  PRD_MAQUINAS: 1007,
  PRD_TIPOS_MAQUINA: 1003,
  PRD_OPERACIONES: 1011,
  PRD_RUTAS_PRODUCCION: 1015,
  PRD_ORDENES_PRODUCCION_LISTADO: 1020,
  PRD_ORDENES_PRODUCCION: 1021,
  PRD_TIEMPOS: 1094,

  // ── RMA ────────────────────────────────────────────────────────────────────
  RMA_SEGUIMIENTO: 1071,
  RMA_ATRIBUTOS: 1066,
  RMA_DEFECTOS: 1062,
  RMA_RESOLUCIONES: 1081,
  RMA_TIPOS_DEFECTO: 1058,

  // ── Servicios ──────────────────────────────────────────────────────────────
  SRV_FACTURACION_MASIVA: 1137,
  SRV_LOTES_FACTURACION: 1132,
  SRV_SERVICIOS_CONTRATADOS: 1129,

  // ── Web ────────────────────────────────────────────────────────────────────
  WEB_PLATAFORMAS: 1105,

  // ── Notificaciones ─────────────────────────────────────────────────────────
  NOTIFICACIONES: 1200,
  CONFIGURACION_NOTIFICACIONES: 1001,
} as const;

export type MenuPermissionId = (typeof MenuPermissions)[keyof typeof MenuPermissions];
